module.exports = __webpack_public_path__ + "img/file-----------------------@1x.a654d270.png";